import p from "react";
import { useTheme as n } from "@chakra-ui/react";
import { MdOutlineZoomIn as a } from "react-icons/md";
import "./button.js";
import { IconButton as s } from "./icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "./masthead-button.js";
import "@chakra-ui/system";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "./close-button.js";
function y({
  currentSlideIndex: o,
  buttonTopPosition: r,
  buttonRightPosition: m,
  zoomButtonText: i,
  zoomButtonClickHandler: e
}) {
  const {
    element: { spacingLarge: t }
  } = n();
  return /* @__PURE__ */ p.createElement(
    s,
    {
      icon: a,
      size: "small",
      variant: "secondary",
      pos: "absolute",
      top: r,
      right: m,
      mt: `-${t}`,
      mr: t,
      transform: "translateY(-100%)",
      onClick: () => e(o)
    },
    i
  );
}
export {
  y as ZoomButton
};
